import { inject } from "vue";
import { MAIN_PAGE } from "../consts/injectProvideKeys.js";
export function getContent(reference, page, parentPage) {
  const content = page.getContent(reference);
  if (content) {
    return content;
  }
  if (!parentPage) {
    parentPage = inject(MAIN_PAGE);
  }
  if (parentPage) {
    return parentPage.getContent(reference);
  }
  return void 0;
}
